import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMaterialSymbolsDashboardCustomize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3 3h8v8H3zm10 0h8v8h-8zM3 13h8v8H3zm13 0h2v3h3v2h-3v3h-2v-3h-3v-2h3z"
	})
});
export default SvgMaterialSymbolsDashboardCustomize;
